import { Button } from '@mantine/core';

export function ButtonNavy({ ...props }) {
  return (
    <>
      <Button variant="filled" c={'white'} color="navy.8" {...props}>
        {props.children}
      </Button>
    </>
  );
}
